/**
 * MentorComposer — the bottom input + send button for the Mentor drawer.
 *
 * Extracted from MentorDrawer.jsx (Feb 2026 A1 refactor).
 *
 * Pure presentation — the parent owns `input` state + the `onSubmit`
 * handler. The placeholder swings on `activeId` so a brand-new
 * conversation gets "Type a question to start a new chat…" copy.
 */
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Loader2, Send } from "lucide-react";

export default function MentorComposer({
  input,
  onChange,
  onSubmit,
  sending,
  activeId,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="border-t-2 border-neutral-900 p-4 flex gap-2 bg-neutral-50 shrink-0"
    >
      <Input
        value={input}
        onChange={(e) => onChange(e.target.value)}
        placeholder={
          activeId
            ? "Reply to your mentor…"
            : "Type a question to start a new chat…"
        }
        disabled={sending}
        data-testid="mentor-input"
        maxLength={4000}
        className="flex-1 min-w-0 rounded-none h-11 border-neutral-300 bg-white"
      />
      <Button
        type="submit"
        disabled={!input.trim() || sending}
        data-testid="mentor-send-btn"
        className="shrink-0 rounded-none bg-[#7C5FB0] hover:bg-[#5E4689] text-white h-11 px-4"
      >
        {sending ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Send className="w-4 h-4" />
        )}
      </Button>
    </form>
  );
}
